import types from './types';
import { CONTACT_BATCH_MODE } from '../../constants';

const defaultState = {
  batchUpdatePossibleFieldsList: [],
  contactBatchMode: CONTACT_BATCH_MODE.ADD
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE:
      return {
        ...state,
        isLoading: true
      };
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS:
      return {
        ...state,
        batchUpdatePossibleFieldsList: data,
        isLoading: false
      };
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false
      };
    case types.SET_CONTACT_BATCH_MODE:
      return {
        ...state,
        contactBatchMode: action.contactBatchMode
      };
    default:
      return state;
  }
};
